import React, { Component } from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import ACL from '@components/ACL'

import { NavLink, withRouter } from 'react-router-dom'

import './Tabs.sass'

/*
  NOTE: currently default tab is "/details"
        with url: "/"
*/
class Tabs extends Component {
  renderTab = ({ tabName, label, link, roles, highlight }) => {
    const tabEl = (
      <NavLink
        exact={!this.props.ignoreExactMatches.includes(tabName)}
        to={link}
        key={tabName}
        activeClassName='tab--active'
        className='tab tab__link'
      >
        <li title={highlight ? 'Search keywords present on this page' : ''}>
          {highlight ? <span className='tab__bullet'>&bull; </span> : ''}
          {label}
        </li>
      </NavLink>
    )

    if (roles && roles.length) {
      return (
        <ACL inline key={tabName} roles={roles}>
          {tabEl}
        </ACL>
      )
    }

    return tabEl
  }

  renderTabs = () => {
    const { defaultTab, tabs, match } = this.props

    return tabs.map(tab => {
      let roles
      let tabName
      let tabUrl

      if (typeof tab === 'string') {
        tabName = tab
        tabUrl = tab
      } else {
        roles = tab.roles
        tabName = tab.tabName || tab.tab
        tabUrl = tab.tab
      }

      let tabSlug = ''
      if (tabUrl !== defaultTab) tabSlug = '/' + tabUrl

      const link = match.url + tabSlug
      const label = tabName.replace(/-/g, ' ')

      return this.renderTab({
        tabName,
        label,
        link,
        roles,
        highlight: tab.highlight
      })
    })
  }

  render () {
    return (
      <div className='tabs__container'>
        <nav className='tabs__scrollable-container'>
          <div className='tabs'>{this.renderTabs()}</div>
        </nav>
      </div>
    )
  }
}

Tabs.defaultProps = {
  ignoreExactMatches: [],
  defaultTab: 'details'
}

Tabs.propTypes = {
  match: PropTypes.object,
  tabs: PropTypes.array.isRequired,
  defaultTab: PropTypes.string,
  ignoreExactMatches: PropTypes.array
}

export default observer(withRouter(Tabs))
